<app-tool-bar [title]="'Dialing Group Configuration'" [iconName]="'pi-phone'" [isAdd]="true"
    (handleAdd)="isAddGroup = true"></app-tool-bar>

<div class="flex flex-col md:flex-row mobile-view">
    <div class="py-3 px-2" style="height: calc(92vh - 55px); flex: 2;">
        <p-card class="p-mb-2" [style]="{height: '100%'}">
            <div class="row">
                <h6 class="mb-3">
                    <i class="pi pi-list" style="margin-right: 5px;"></i>
                    Groups List
                </h6>

                <p-divider></p-divider>

                <div *ngIf="!initalLoadGroup">
                    <ul class="list-group" style="padding-right: 3px;">
                        <li *ngFor="let item of allContactGroups"
                            class="list-group-item flex justify-between items-center" style="height: 40px;
                            cursor: pointer;
                            overflow: hidden;
                            padding: 0px 10px;" (click)="handleChangeGroup(item)"
                            [ngClass]="{ 'active': currentSelectedContactGroupID === item.id }">
                            <div class="flex justify-between items-center w-full">
                                <div class="item-name" pTooltip="{{ item.name }}" tooltipPosition="right">
                                    {{ item.name }}
                                </div>
                                <!-- <p-button icon="pi pi-ellipsis-v" class="p-button-text"
                                    [pMenuTrigger]="menu"></p-button>
                                <p-menu #menu [model]="getMenuItems(item)"></p-menu> -->
                                <p-menu [tabindex]="undefined" #menu [model]="menuItems" [popup]="true"
                                    appendTo="body"></p-menu>
                                <i (click)="menu.toggle($event)" class="pi pi-ellipsis-v action-button"></i>
                            </div>

                            <div *ngIf="allContactGroups.length === 0" style="font-weight: 600;">
                                No Contact Groups Found !!
                            </div>
                        </li>
                    </ul>
                </div>

                <div *ngIf="!initalLoadGroup && allContactGroups.length === 0" class="flex justify-center items-center"
                    style="height: 54vh;">
                    <p class="font-bold text-xl">No Dialing Groups Found !!</p>
                </div>

                <div class="spinner" *ngIf="initalLoadGroup"
                    style="height: 54vh; display: flex; justify-content: center; align-items: center;">
                    <p-progress-spinner></p-progress-spinner>
                </div>
            </div>

        </p-card>
    </div>

    <div class="flex-1 py-3 pr-4 ml-3 md:ml-0" style="height: calc(92vh - 55px); flex: 6;">
        <div class="right-box" [style]="{height: '100%'}">
            <app-dialing-group-list
                [toggleFlag]="toggleFlag"
                [currentSelectedContactGroupID]="currentSelectedContactGroupID"></app-dialing-group-list>
    </div>
    </div>


</div>


<p-dialog [modal]="true" [(visible)]="isAddGroup" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }" closable="false"
    [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isAddGroup">
        <app-create-dialing-group (closeDialog)="isAddGroup = false"
            (reload)="reloadContactGroup('Create')"></app-create-dialing-group>
    </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isEditGroup" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isEditGroup">
        <app-create-dialing-group (closeDialog)="isEditGroup = false" [templateDataToEdit]="dataToEdit"
            [type]="'Edit'"
            (reload)="reloadContactGroup('Edit')"></app-create-dialing-group>
    </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isAddContact" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '80vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isAddContact">
        <app-add-contact-in-group (closeDialog)="isAddContact = false" [selectedGroupId]="currentSelectedContactGroupID"
            (reload)="reloadListData()"></app-add-contact-in-group>
    </ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isDeleteGroup" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">

    <div class="flex items-center justify-center dialog-header ">
        Delete Template

        <div class="absolute right-2">
            <button (click)="isDeleteGroup = false" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <div class="mt-2 mb-2" style="font-weight: 500; font-size: 17px; text-align: center;">
            Are you sure you want to delete this Group : {{dataToEdit?.name}}
        </div>

        <div class="flex gap-4 mt-7 justify-end">

            <p-button label="Cancel" severity="danger" variant="outlined" (click)="isDeleteGroup = false"></p-button>
            <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="handleDelete()"
                [disabled]="btnLoading" [loading]="btnLoading">
            </p-button>


        </div>

    </div>

</p-dialog>


<p-dialog [modal]="true" [(visible)]="isImportContact" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isImportContact">
        <app-bulk-import-dialing-content (closeDialog)="isImportContact = false" [selectedGroupId]="currentSelectedContactGroupID"
            (reload)="reloadListData()"></app-bulk-import-dialing-content>
    </ng-container>
</p-dialog>